/**
 * @file
 * Detect touch devices on base of events to respect mixed input devices.
 */

(function ($, Drupal) {
  Drupal.behaviors.touch = {
    attach: function attach(context) {
      $(document).on('touchstart', function (event) {
        $('html').addClass('is-touched');
      });
    }
  };
})(jQuery, Drupal);
